import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
render(<App data-id="element-356" />, document.getElementById('root'));
// Clean up Magic Patterns references after render
requestAnimationFrame(() => {
  // Set proper page title
  document.title = 'Fresno Management Company';
  // Remove all HTML comments
  const walker = document.createTreeWalker(document, NodeFilter.SHOW_COMMENT);
  const toRemove: Comment[] = [];
  while (walker.nextNode()) {
    toRemove.push(walker.currentNode as Comment);
  }
  toRemove.forEach(node => node.remove());
  // Remove meta/link tags referencing magicpatterns.com
  const head = document.head;
  const metaTags = head.querySelectorAll('meta');
  metaTags.forEach(tag => {
    const content = tag.getAttribute('content') || '';
    if (content.includes('magicpatterns.com') || content.includes('Magic Patterns')) {
      tag.remove();
    }
  });
  // Remove only the image_src link tag pointing to magicpatterns preview
  const imageSrcLink = head.querySelector('link[rel="image_src"]');
  if (imageSrcLink && (imageSrcLink.getAttribute('href') || '').includes('magicpatterns.com')) {
    imageSrcLink.remove();
  }
  // Update og:image / twitter:image if they point to magicpatterns
  const ogImage = head.querySelector('meta[property="og:image"]');
  if (ogImage && ogImage.getAttribute('content')?.includes('magicpatterns')) {
    ogImage.setAttribute('content', 'https://cdn.boostifyusa.com/og-image.png');
  }
  const twitterImage = head.querySelector('meta[name="twitter:image"]');
  if (twitterImage && twitterImage.getAttribute('content')?.includes('magicpatterns')) {
    twitterImage.setAttribute('content', 'https://cdn.boostifyusa.com/og-image.png');
  }
  // Update generator meta tag
  const generator = head.querySelector('meta[name="generator"]');
  if (generator && generator.getAttribute('content')?.includes('Magic Patterns')) {
    generator.remove();
  }
});